<div class="search-modal z-50 fixed p-5 shadow-lg
 glass-background text-white md:w-1/2 w-full   md:min-h-96 md:max-h-96 h-full fixed " style="place-self: anchor-center;">
    <div class="flex w-full justify-end mb-2  hover:text-red-500">
        <button class="close-button" (click)="closeSearchModal()">
            <i class="pi pi-times"></i>
        </button>
    </div>
    <div class="search-modal-input ">
        <form class="flex justify-between gap-5  items-center" (ngSubmit)="navigateToProductList()">
            <input #searchInput type="text"  name="searchProduct" [(ngModel)]="searchProduct"
                placeholder="Search Shilajit, Sugar, Hair Use Case..."
                class="shadow-lg w-full p-2 pl-8 ring-1 ring-gray-500 focus:ring-black pr-3 text-black outline-none rounded-full">
            <i class="pi pi-search hover:text-primary cursor-pointer hover:scale-105" (click)="navigateToProductList()"></i>
        </form>

    </div>
    <div class="search-modal-output overflow-auto md:max-h-72 h-screen flex  justify-center gap-5">
        <div class="search-modal-output-list p-2 ">
            <ul class="flex flex-col gap-2">
                <li class=" w-full p-2 
                transition text-white 
                cursor-pointer flex flex-col gap-2" *ngFor="let data of products">
                    <div class="flex justify-start gap-2 align-items-center">
                        <img class="w-10 h-10" [src]="data.image">
                        <div>
                            <a class="" (click)="navigateToProduct(data)">{{data.name}}</a>
                            <p class="text-opacity-50 text-xs" [innerHTML]="tags(data.tags)"><span
                                    class="rupee font-bold "></span> </p>
                        </div>
                    </div>
                    <hr class="border-white">
                </li>
            </ul>
            <div *ngIf="products.length<1 && !loading" class="text-black">
                <div *ngIf="searchProduct" class="no-result text-center">
                    <p class="">No results found for : <br>
                        <span class="text-lg font-bold">{{searchProduct}}</span>
                    </p>
                </div>
                <div *ngIf="!searchProduct" class="no-result text-center my-5">
                   <i class="pi pi-search text-5xl"></i>
                   <p class="text-2xl">Search</p>
                </div>
            </div>
            <div *ngIf="loading" class="mx-auto cardLoader"></div>
        </div>
    </div>
</div>